import React, { useState } from 'react';
import { Button, Form, Row, Col, Alert } from 'react-bootstrap';

interface SearchFormProps {
  onSuccess: () => void;
  onCancel: () => void;
  disabled?: boolean;
}

const SearchForm: React.FC<SearchFormProps> = ({ onSuccess, onCancel, disabled }) => {
  const [searchValue, setSearchValue] = useState('');
  const [position, setPosition] = useState<'prefix' | 'postfix' | 'anywhere'>('prefix');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!/^[0-9]+$/.test(searchValue)) {
      setError('Search value must be numbers only.');
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch('/api/searches', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          search_value: searchValue,
          position,
          country_code: '+1',
          expiration: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
        }),
        credentials: 'include',
      });
      const data = await res.json();
      if (res.ok && data.status === 'success') {
        onSuccess();
      } else {
        setError(data.message || 'Failed to create search.');
      }
    } catch (err) {
      setError('Network error.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit} className="p-3 border rounded bg-white">
      <h5 className="mb-3">Create New Search</h5>
      {error && <Alert variant="danger">{error}</Alert>}
      <Row className="mb-3">
        <Col>
          <Form.Label>Search Value</Form.Label>
          <Form.Control
            type="text"
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            maxLength={10}
            pattern="[0-9]+"
            required
            disabled={submitting || disabled}
            placeholder="e.g. 555"
          />
        </Col>
        <Col>
          <Form.Label>Search Type</Form.Label>
          <Form.Select
            value={position}
            onChange={e => setPosition(e.target.value as any)}
            disabled={submitting || disabled}
          >
            <option value="prefix">Prefix</option>
            <option value="postfix">Postfix</option>
            <option value="anywhere">Anywhere</option>
          </Form.Select>
        </Col>
      </Row>
      <div className="d-flex gap-2">
        <Button type="submit" variant="primary" disabled={submitting || disabled}>
          {submitting ? 'Creating...' : 'Create Search'}
        </Button>
        <Button variant="secondary" onClick={onCancel} disabled={submitting}>
          Cancel
        </Button>
      </div>
    </Form>
  );
};

export default SearchForm;
